import { render, staticRenderFns } from "./JumpPrompt.vue?vue&type=template&id=34931530&scoped=true"
import script from "./JumpPrompt.vue?vue&type=script&lang=js"
export * from "./JumpPrompt.vue?vue&type=script&lang=js"
import style0 from "./JumpPrompt.vue?vue&type=style&index=0&id=34931530&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34931530",
  null
  
)

export default component.exports